/**
 * Atom: PersonStatusPill
 *
 * The "Not activated" / "Invited" pill required next to a person's name
 * everywhere people are listed (#1548). Thin Pill wrapper over the shared
 * portal-status vocabulary — see @/lib/portalStatus for the label/tone map.
 * Renders nothing for 'active' (or unknown/n/a) status: a pill on every
 * activated person is noise.
 *
 *   <PersonStatusPill status={contact.portal_status} />
 *   <PersonStatusPill status={portalStatusFromAssignablePerson(person)} />
 */
import React from 'react'
import { Pill } from '@/components/atoms/Pill'
import { normalizePortalStatus, PORTAL_STATUS_LABEL, PORTAL_STATUS_TONE, type PortalStatus } from '@/lib/portalStatus'

export interface PersonStatusPillProps {
  status?: PortalStatus | string | null
  size?: 'sm' | 'md'
  className?: string
}

export const PersonStatusPill: React.FC<PersonStatusPillProps> = ({ status, size = 'sm', className }) => {
  const s = normalizePortalStatus(status ?? null)
  if (!s) return null
  const label = PORTAL_STATUS_LABEL[s]
  if (!label) return null
  return (
    <Pill tone={PORTAL_STATUS_TONE[s]} size={size} className={className}>
      {label}
    </Pill>
  )
}

export default PersonStatusPill
